import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const EditRowIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M1.5 4.5V6H10.5V4.5H1.5ZM1.5 7.5V9H10.5V7.5H1.5ZM15.03 7.5975C14.925 7.5975 14.82 7.6425 14.7375 7.725L13.9875 8.475L15.525 10.0125L16.275 9.2625C16.44 9.105 16.44 8.8425 16.275 8.685L15.315 7.725C15.2325 7.6425 15.135 7.5975 15.03 7.5975ZM13.5525 8.91L9 13.455V15H10.545L15.09 10.4475L13.5525 8.91ZM1.5 10.5V12H7.5V10.5H1.5Z" />
  </SvgIcon>
);
